import { useState, useEffect } from 'react';

const navItems = [
  { label: 'Conceito', href: '#conceito' },
  { label: 'Experiência', href: '#experiencia' },
  { label: 'Patrocínio', href: '#patrocinio' },
  { label: 'Inscrição', href: '#inscricao' },
];

interface NavbarProps {
  onParticipate: () => void;
}

export default function Navbar({ onParticipate }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    if (href === '#inscricao') {
      onParticipate();
      return;
    }
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-obsidian/95 backdrop-blur-md border-b border-gold/20 py-3'
          : 'bg-transparent py-4'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Espaço reservado para manter o justify-between */}
        <div className="w-10" />

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <button
              key={item.href}
              onClick={() => handleNavClick(item.href)}
              className="font-sans text-xs tracking-widest uppercase text-cream/70 hover:text-gold transition-colors duration-300 cursor-pointer whitespace-nowrap"
              style={{ letterSpacing: '0.2em' }}
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => onParticipate()}
            className="font-sans text-xs tracking-widest uppercase border border-gold text-gold px-5 py-2 hover:bg-gold hover:text-obsidian transition-all duration-300 cursor-pointer whitespace-nowrap"
            style={{ letterSpacing: '0.15em' }}
          >
            Garantir Presença
          </button>
        </nav>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center text-gold cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label={menuOpen ? 'Fechar menu' : 'Abrir menu'}
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-xl`} />
        </button>
      </div>

      {/* Mobile menu dropdown */}
      {menuOpen && (
        <div className="md:hidden bg-obsidian border-t border-gold/20 px-6 py-6 flex flex-col gap-5">
          {navItems.map((item) => (
            <button
              key={item.href}
              onClick={() => handleNavClick(item.href)}
              className="font-sans text-xs tracking-widest uppercase text-cream/70 hover:text-gold transition-colors duration-300 cursor-pointer text-left whitespace-nowrap"
              style={{ letterSpacing: '0.2em' }}
            >
              {item.label}
            </button>
          ))}
          <button
            onClick={() => {
              setMenuOpen(false);
              onParticipate();
            }}
            className="font-sans text-xs tracking-widest uppercase border border-gold text-gold px-5 py-3 hover:bg-gold hover:text-obsidian transition-all duration-300 cursor-pointer whitespace-nowrap self-start"
            style={{ letterSpacing: '0.15em' }}
          >
            Garantir Presença
          </button>
        </div>
      )}
    </header>
  );
}
